import { createContext } from 'react';

















const context = createContext({ state: {}, actions: {} });

export default context;
export const CreditsConsumer = context.Consumer;